import "./Style.css";

const InfoCardSelector = ({
  label,
  name,
  icon,
  options,
  hoverColor = "green",
  onChange,
  selectedOption,
}) => {
  const getColorClass = (isSelected) => {
    if (isSelected) {
      return hoverColor === "green"
        ? "info-card-selector-button-green-selected"
        : "info-card-selector-button-purple-selected";
    } else {
      return hoverColor === "green"
        ? "info-card-selector-button-green"
        : "info-card-selector-button-purple";
    }
  };
  return (
    <div>
      <label className="info-card-selector-label">
        {icon}
        {label}
      </label>

      <div className="info-card-selector-grid">
        {options.map((option) => {
          const isSelected = selectedOption === option.id;
          return (
            <button
              name={name}
              key={option.id}
              type="button"
              className={`info-card-selector-button ${getColorClass(isSelected)}`}
              onClick={() =>
                onChange({
                  target: { name, value: option.id },
                })
              }
            >
              <div className="info-card-selector-button-title">{option.title}</div>
              <div className="info-card-selector-button-description">{option.description}</div>
            </button>
          );
        })}
      </div>
    </div>
  );
};
export default InfoCardSelector;
